import React from 'react';

import ImageLoader from './ImageLoader';

const PostTextAndImages = ({ post }) => (
  <React.Fragment>
    <p>{post.text}</p>

    {post.postType === 'image' &&
      <div className='Table__images__wrapper'>
        {post.images.map((image, i) => (
          <div key={i} className='ImageBorder ImageBorder--square'>
            <ImageLoader
              renderAsImg={true}
              url={image.url}
            />
          </div>
        ))}
      </div>
    }
  </React.Fragment>
)

export default PostTextAndImages
